module.exports = __webpack_public_path__ + "media/icons/naped-4x4-grey-ba0fb111.png";